"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Default_1 = __importDefault(require("./Default"));
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/bridges`;
    }
    /**
     * Creates a new bridge for the user specified by **accountId** and **extensionId** identifiers. The request body
   * should contain JSON object which describes properties of the new bridge.
   * The bridge can be created by a user himself, his delegate or any user who has the **Super Admin** privilege.
   *
     * HTTP Method: post
     * Endpoint: /rcvideo/v2/account/{accountId}/extension/{extensionId}/bridges
     * Rate Limit Group: Heavy
     * App Permission: Video
     */
    async post(createBridgeRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createBridgeRequest, undefined, restRequestConfig);
        return r.data;
    }
    default() {
        return new Default_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map